module.exports = __webpack_public_path__ + "static/media/fachada2.25785de4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Fachada/fachada2.jpg
// module id = 324
// module chunks = 0